export var Pagination;
(function (Pagination) {
    Pagination[Pagination["DEFAULT_PAGE_SIZE"] = 10] = "DEFAULT_PAGE_SIZE";
    Pagination[Pagination["DEFAULT_PAGE_NO"] = 1] = "DEFAULT_PAGE_NO";
})(Pagination || (Pagination = {}));
